import styled from 'styled-components';

const Button = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  background-color: transparent;
  border: 0;
  font-size: 1.375rem;
  color: ${Styles.color.primary};
  padding: 0;
  height: 40px;
  &[disabled] {
    svg {
      fill: ${Styles.color.grey.four};
      pointer-events: none;
    }
  }
`;

export default Button;
